module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "editor"
  }, [_c('h1', [_vm._v("Job Names Mapping Config Editor")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.initial",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "initial": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-vv-rules": "required|uniqueJobName",
      "name": "toName"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.finish
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Finish and Save")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "text-danger"
  }, [(_vm.errors.has('toName')) ? _c('li', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('toName')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('hsNames')) ? _c('li', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('hsNames')))]) : _vm._e(), _vm._v(" "), (_vm.available.length === 0) ? _c('li', {
    staticClass: "text-danger"
  }, [_vm._v("There are no available job names. You will need to either remove some from another job name config or add the approriate job name in Hot Schedules.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "hs-names"
  }, [_c('draggable', {
    staticClass: "draglist",
    attrs: {
      "list": _vm.hsNames,
      "options": _vm.hsOptions
    },
    on: {
      "add": _vm.updateHsNameCount,
      "remove": _vm.updateHsNameCount
    }
  }, _vm._l((_vm.hsNames), function(name) {
    return _c('div', {
      staticClass: "hs-name"
    }, [_vm._v(_vm._s(name))])
  }))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hsNameCount),
      expression: "hsNameCount"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: (_vm.hsNameCount),
      expression: "hsNameCount",
      modifiers: {
        "initial": true
      }
    }],
    attrs: {
      "type": "hidden",
      "name": "hsNames",
      "data-vv-rules": "notEmptyList|required"
    },
    domProps: {
      "value": _vm._s(_vm.hsNameCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hsNameCount = $event.target.value
      }
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "available-names"
  }, [_c('draggable', {
    staticClass: "draglist",
    attrs: {
      "list": _vm.available,
      "options": _vm.availableOptions
    },
    on: {
      "start": function($event) {
        _vm.dragging = true
      }
    }
  }, _vm._l((_vm.available), function(name) {
    return _c('div', {
      staticClass: "available-job"
    }, [_vm._v(_vm._s(name))])
  }))])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-arrow-circle-left pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Schoox Job Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-arrow-circle-left pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Hot Schedules Job Names")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v("Available Jobs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "editor-instructions text-center"
  }, [_vm._v("Add/Remove Job Names by dragging them."), _c('br'), _vm._v(" Note: any jobs used in another configuration row will not appear in the available jobs list.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd23cb5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobNameMapEditor.vue
// module id = 417
// module chunks = 2